import { EditableCategory, CategorySummary } from "..";
import { scaffoldEdit } from "../../../common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "CATEGORY/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "CATEGORY/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "CATEGORY/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "CATEGORY/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "CATEGORY/SAVE__EDITABLE_SUCCESS",
    SAVE_FAILURE = "CATEGORY/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditableCategory, CategorySummary, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };
